module.exports = __webpack_public_path__ + "img/cooperativeMedia14.7e4468b1.png";